'use client';

import { TimeLeftUntilTomorrowComponent } from './time-left-until-tomorrow.component';

export const TimeLeftUntilTomorrowShortLabelsComponent = () => <TimeLeftUntilTomorrowComponent shortLabels={true} />;
